import { api } from '@/api'

export interface ServiceType {
  id: string
  name: string
  slug: string
  isActive: boolean
  servicesCount: number
  createdAt: string
}

export interface ServiceTypeOption extends ServiceType {
  label: string
  value: string
}

export interface ServiceTypesFilters {
  page?: number
  [key: string]: string | number | boolean | undefined | null
}

export interface ServiceTypesResponse {
  data: ServiceType[]
  meta: {
    message: string
    errors: unknown[]
  }
  pagination: {
    currentPage: number
    perPage: number
    total: number
    lastPage: number
    from: number | null
    to: number | null
  }
}

export function getServiceTypesAction(filters: ServiceTypesFilters = {}): Promise<ServiceTypesResponse> {
  const params = new URLSearchParams()

  params.append('page', String(filters.page ?? 1))

  Object.entries(filters).forEach(([key, value]) => {
    if (key !== 'page' && value !== '' && value !== null && value !== undefined) {
      params.append(`filter[${key}]`, String(value))
    }
  })

  return api.v2.get<ServiceTypesResponse>(`/service-types?${params.toString()}`)
}
